import { Box } from '@evaneos/b2b-ui';

import s from './Discussion.module.css';

type MessageAttachmentProps = {
    name: string;
    type: string;
    link?: string;
};

export const MessageAttachment = ({ name, type, link, ...props }: MessageAttachmentProps) => {
    if (link) {
        return (
            <a href={link} className={s.attachment} {...props}>
                <div className={s.type}>{type}</div>
                <p>{name}</p>
            </a>
        );
    }

    return (
        <Box className={s.attachment} {...props}>
            <div className={s.type}>{type}</div>
            <p>{name}</p>
        </Box>
    );
};
